import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { LocationStatusApi, LocationTypeApi } from '../server/LocationLookupApi';

export const LocationTypeActions = {
    getAll: () => {
        const types = {
            success: ActionTypes.LOCATION_TYPE_LIST,
            failure: ActionTypes.LOCATION_TYPE_LIST_ERROR,
        };
        return CentricDispatcher.dispatchAsync(LocationTypeApi.getAll(), types);

    }
};

export const LocationStatusActions = {
    getAll: () => {
        const types = {
            success: ActionTypes.LOCATION_STATUS_LIST,
            failure: ActionTypes.LOCATION_STATUS_LIST_ERROR,
        };
        return CentricDispatcher.dispatchAsync(LocationStatusApi.getAll(), types);

    }
};
